import React from "react";
import { FormattedMessage } from "react-intl";
import MarkdownPage from "../MarkdownPage";

import koDoc from "./TermsOfService.ko.md";
import enDoc from "./TermsOfService.en.md";

const docs = {
  "ko-KR": koDoc,
  "en-US": enDoc,
};

const TermsOfService = () => (
  <MarkdownPage title={<FormattedMessage id="page_terms_title" />} docs={docs} />
);

export default TermsOfService;
